if (!customElements.get('adev-cart-drawer-upsell')) {
    customElements.define('adev-cart-drawer-upsell', class adevCartDrawerUpsell extends HTMLElement {
        constructor() {
            super();

            this.variants = [];
            this.currentVariant = {};
        }

        initVariantSelector() {
            const variantEl = this.querySelector('[data-adev-cart-drawer-upsell="variant-select"]');
            if (!variantEl) return;

            variantEl.addEventListener('change', this.onVariantChange.bind(this));
        }

        setCurrentVariant() {
            const variantEl = this.querySelector('[data-adev-cart-drawer-upsell="variant-select"]');

            if (variantEl) {
                const selectedVariantId = variantEl.value;
                this.currentVariant = this.variants.find(variant => variant.id === parseInt(selectedVariantId));
                return;
            }

            this.currentVariant = this.variants.find(variant => variant.available) || this.variants[0];
        }

        updateImage() {
            const imageEl = this.querySelector('[data-adev-cart-drawer-upsell="image"]');
            if (!imageEl || !this.currentVariant) return;

            const featuredImage = this.currentVariant.featured_image;
            if (!featuredImage || !featuredImage.src) return;

            const src = featuredImage.src.includes('_150x')
                ? featuredImage.src
                : featuredImage.src.replace(/(\.(jpg|jpeg|gif|png|webp|avif)(\?.*)?)$/i, '_150x$1');

            imageEl.src = src;
            imageEl.alt = featuredImage.alt || '';
        }

        updatePrices() {
            const pricesEl = this.querySelector('[data-adev-cart-drawer-upsell="prices"]')
                || this.querySelector('[data-adev-cart-drawer-upsell="button-prices"]');
            if (!pricesEl) return;

            const compareAtPriceEl = this.querySelector('[data-adev-cart-drawer-upsell="compare-at-price"]');
            const priceEl = this.querySelector('[data-adev-cart-drawer-upsell="price"]');

            const compareAtPrice = this.currentVariant.compare_at_price;
            const price = this.currentVariant.price;
            const onSale = compareAtPrice > price;

            pricesEl.setAttribute('data-on-sale', onSale);

            if (compareAtPriceEl) {
                if (onSale) {
                    const strikeEl = document.createElement('s');
                    strikeEl.textContent = Shopify.formatMoney(compareAtPrice);
                    compareAtPriceEl.innerHTML = '';
                    compareAtPriceEl.appendChild(strikeEl);
                } else {
                    compareAtPriceEl.innerHTML = '';
                }
            }

            if (priceEl) {
                priceEl.textContent = Shopify.formatMoney(price);
            }
        }

        updateAddToCartButton() {
            const atcButton = this.querySelector('[data-adev-cart-drawer-upsell="add-to-cart"]');
            if (!atcButton) return;

            atcButton.disabled = !this.currentVariant.available;
        }

        onVariantChange() {
            this.setCurrentVariant();
            this.updateImage();
            this.updatePrices();
            this.updateAddToCartButton();
        }

        initForm() {
            const atcButton = this.querySelector('[data-adev-cart-drawer-upsell="add-to-cart"]');
            if (!atcButton) return;

            atcButton.addEventListener('click', this.onAddToCartClick.bind(this));
        }

        onAddToCartClick() {
            const atcButton = this.querySelector('[data-adev-cart-drawer-upsell="add-to-cart"]');

            atcButton.classList.add('is--loading');

            const formData = new FormData();
            formData.append('id', this.currentVariant.id);
            formData.append('quantity', 1);
            formData.append('sections', 'adev-cart-drawer');

            fetch( Theme.routes.cart_add_url, {
                method: 'POST',
                body: formData,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            })
            .then(response => {
                return response.json();
            })
            .then(data => {
                if (data.message) {
                    alert(data.message);
                    atcButton.classList.remove('is--loading');
                    return;
                }

                document.dispatchEvent(new CustomEvent('adev:cart-drawer:refresh', { detail: data.sections }));
                
                atcButton.classList.remove('is--loading');
            })
            .catch(error => {
                console.error('There was a problem with the fetch operation:', error);
                atcButton.classList.remove('is--loading');
            });
        }

        loadData() {
            const jsonData = this.querySelector('[data-adev-cart-drawer-upsell="product-json"]');
            if (!jsonData) return;

            this.variants = JSON.parse(jsonData.innerHTML);
        }

        init(){
            this.loadData();
            this.setCurrentVariant();
            this.initVariantSelector();
            this.initForm();
        }

        connectedCallback() {
            this.init();
        }

        disconnectedCallback() {
            
        }

    });
}